import type { CourseTheme, LandmarkSlot } from "../types/courseTheme";

export const courseThemes: Record<string, CourseTheme> = {
  es: {
    accent: "221 125 88",
    accent2: "236 184 82",
    pattern: "azulejo",
    landmarks: [
      { art: "sagrada", name: "La Sagrada Família", place: "Barcelona" },
      { art: "alhambra", name: "La Alhambra", place: "Granada" },
      { art: "windmill", name: "Los molinos de Consuegra", place: "La Mancha" },
      { art: "torreOro", name: "La Torre del Oro", place: "Sevilla" },
      { art: "alcala", name: "La Puerta de Alcalá", place: "Madrid" },
      { art: "mezquita", name: "La Mezquita", place: "Córdoba" },
    ],
  },
  fr: {
    accent: "118 138 196",
    accent2: "226 150 140",
    pattern: "wave",
    landmarks: [
      { art: "eiffel", name: "La tour Eiffel", place: "Paris" },
      { art: "arc", name: "L'Arc de Triomphe", place: "Paris" },
      { art: "notreDame", name: "Notre-Dame", place: "Paris" },
    ],
  },
  de: {
    accent: "112 146 116",
    accent2: "226 188 110",
    pattern: "diamond",
    landmarks: [
      { art: "brandenburg", name: "Das Brandenburger Tor", place: "Berlin" },
      { art: "neuschwanstein", name: "Schloss Neuschwanstein", place: "Bayern" },
      { art: "kolnerDom", name: "Der Kölner Dom", place: "Köln" },
    ],
  },
  it: {
    accent: "196 120 96",
    accent2: "226 198 96",
    pattern: "diamond",
    landmarks: [
      { art: "colosseo", name: "Il Colosseo", place: "Roma" },
      { art: "pisa", name: "La Torre di Pisa", place: "Pisa" },
      { art: "duomo", name: "Il Duomo", place: "Firenze" },
    ],
  },
  en: {
    accent: "130 120 180",
    accent2: "208 116 110",
    pattern: "dots",
    landmarks: [
      { art: "bigBen", name: "Big Ben", place: "London" },
      { art: "towerBridge", name: "Tower Bridge", place: "London" },
      { art: "londonEye", name: "The London Eye", place: "London" },
    ],
  },
  pt: {
    accent: "92 130 190",
    accent2: "236 184 82",
    pattern: "azulejo",
    landmarks: [
      { art: "belem", name: "A Torre de Belém", place: "Lisboa" },
      { art: "tram28", name: "O elétrico 28", place: "Lisboa" },
      { art: "ponte25", name: "A Ponte 25 de Abril", place: "Lisboa" },
    ],
  },
};

export const fallbackTheme: CourseTheme = {
  accent: "108 104 222",
  accent2: "236 184 82",
  pattern: "dots",
  landmarks: [],
};

/** Ordered so the first three alternate sides; landmarks hug the edges, clear of the lesson path. */
export const landmarkSlots: LandmarkSlot[] = [
  { side: "left", edge: 12, top: 5, width: 200, depth: 1 },
  { side: "right", edge: 8, top: 33, width: 210, depth: 0.7 },
  { side: "left", edge: -8, top: 62, width: 200, depth: 1.2 },
  { side: "right", edge: 16, top: 3, width: 180, depth: 0.8 },
  { side: "left", edge: 4, top: 34, width: 190, depth: 0.6 },
  { side: "right", edge: 4, top: 64, width: 200, depth: 1 },
];
